export class Storage {
    static set(key, value, isLocal = true) {
        if (isLocal) {
            localStorage.setItem(key, value);
        } else {
            sessionStorage.setItem(key, value);
        }
    }
    static get(key, isLocal = true) {
        if (isLocal) {
            return localStorage.getItem(key);
        }
        return sessionStorage.getItem(key);
    }
    static remove(key, isLocal = true) {
        if (isLocal) {
            localStorage.removeItem(key);
        } else {
            sessionStorage.removeItem(key);
        }
    }
    static clearAll(isLocal = true) {
        let clearKeys = ['routePaths', 'TENANT_KEY', 'userInfo'];
        if (isLocal) {
            Object.keys(localStorage).forEach(function (key) {
                if (clearKeys.includes(key)) {
                    localStorage.removeItem(key);
                }
            });
        } else {
            Object.keys(sessionStorage).forEach(function (key) {
                if (clearKeys.includes(key)) {
                    sessionStorage.removeItem(key);
                }
            });
        }
    }

    static clearAllExcept = (exceptKeys) => {
        Object.keys(localStorage).forEach(function (key) {
            if (!exceptKeys.includes(key)) {
                localStorage.removeItem(key);
            }
        });
    };
}
